// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.self-consent {
  margin: 0 0 1.25rem;
  padding: 16px;
  border-radius: 18px;
  background: var(--bg-card, var(--surface-color));
  border: var(--border-card, 1px solid var(--border-color));
  color: var(--text-color);
  box-sizing: border-box;
}

.self-consent__title {
  margin: 0 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--text-color);
}

.self-consent__help {
  margin: 0 0 0.9rem;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--text-secondary);
}

.self-consent__error {
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
  color: var(--brand-danger, #ff453a);
}

.self-consent__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.self-consent__item {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid var(--border-color);
  background: color-mix(in srgb, var(--text-color) 3%, transparent);
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;
}

.self-consent__icon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 13px;
  flex-shrink: 0;
}

.self-consent__item--video .self-consent__icon {
  color: var(--brand-primary, #0877bc);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.self-consent__item--heart .self-consent__icon {
  color: #ff453a;
  background: rgba(255, 69, 58, 0.12);
}

.self-consent__item--public .self-consent__icon {
  color: #d97706;
  background: rgba(217, 119, 6, 0.12);
}

.self-consent__item--public.is-granted {
  border-color: rgba(217, 119, 6, 0.34);
  background: rgba(217, 119, 6, 0.08);
}

.self-consent__item--video.is-granted {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.38);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
}

.self-consent__item--heart.is-granted {
  border-color: rgba(255, 69, 58, 0.34);
  background: rgba(255, 69, 58, 0.08);
}

.self-consent__item--video.is-granted .self-consent__icon {
  color: #fff;
  background: var(--brand-primary, #0877bc);
}

.self-consent__item--heart.is-granted .self-consent__icon {
  color: #fff;
  background: #ff453a;
}

.self-consent__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.self-consent__label {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-color);
  line-height: 1.25;
}

.self-consent__detail {
  font-size: 0.78rem;
  line-height: 1.35;
  color: var(--text-secondary);
}

.self-consent__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.self-consent__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.55;
}

.self-consent__status.is-on {
  color: #16803c;
}

.self-consent__status.is-on .self-consent__status-dot {
  opacity: 1;
  box-shadow: 0 0 0 3px rgba(22, 128, 60, 0.16);
}

.self-consent__btn {
  flex-shrink: 0;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0.48rem 0.95rem;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  cursor: pointer;
  transition:
    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    background-color 0.2s ease,
    border-color 0.2s ease,
    filter 0.2s ease;
}

.self-consent__btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.self-consent__btn:active:not(:disabled) {
  transform: scale(0.97);
}

.self-consent__btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.self-consent__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.self-consent__btn--grant {
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.self-consent__btn--withdraw {
  background: var(--profile-hover-bg, transparent);
  color: var(--text-color);
  border-color: var(--border-color);
}

@media (prefers-reduced-motion: reduce) {
  .self-consent__item,
  .self-consent__btn {
    transition: none;
  }

  .self-consent__btn:hover:not(:disabled),
  .self-consent__btn:active:not(:disabled) {
    transform: none;
  }
}

.light-mode .self-consent,
html[data-theme="light"] .self-consent {
  background: #f3f4f6;
  border: 1px solid rgba(17, 24, 39, 0.12);
  color: #111827;
}

.light-mode .self-consent__title,
.light-mode .self-consent__label,
html[data-theme="light"] .self-consent__title,
html[data-theme="light"] .self-consent__label {
  color: #111827;
}

.light-mode .self-consent__help,
.light-mode .self-consent__detail,
html[data-theme="light"] .self-consent__help,
html[data-theme="light"] .self-consent__detail {
  color: #4b5563;
}

.light-mode .self-consent__item,
html[data-theme="light"] .self-consent__item {
  background: #ffffff;
  border-color: rgba(17, 24, 39, 0.1);
}

.light-mode .self-consent__item--video.is-granted,
html[data-theme="light"] .self-consent__item--video.is-granted {
  background: rgba(8, 119, 188, 0.07);
  border-color: rgba(8, 119, 188, 0.28);
}

.light-mode .self-consent__item--heart.is-granted,
html[data-theme="light"] .self-consent__item--heart.is-granted {
  background: rgba(255, 69, 58, 0.07);
  border-color: rgba(255, 69, 58, 0.26);
}

.light-mode .self-consent__status,
html[data-theme="light"] .self-consent__status {
  color: #6b7280;
}

.light-mode .self-consent__status.is-on,
html[data-theme="light"] .self-consent__status.is-on {
  color: #15803d;
}

.light-mode .self-consent__btn--withdraw,
html[data-theme="light"] .self-consent__btn--withdraw {
  background: #ffffff;
  color: #111827;
  border-color: rgba(17, 24, 39, 0.18);
}

.light-mode .self-consent__error,
html[data-theme="light"] .self-consent__error {
  color: #b91c1c;
}

.dark-mode .self-consent,
html[data-theme="dark"] .self-consent {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #f9fafb;
}

.dark-mode .self-consent__title,
.dark-mode .self-consent__label,
html[data-theme="dark"] .self-consent__title,
html[data-theme="dark"] .self-consent__label {
  color: #f9fafb;
}

.dark-mode .self-consent__help,
.dark-mode .self-consent__detail,
html[data-theme="dark"] .self-consent__help,
html[data-theme="dark"] .self-consent__detail {
  color: #d1d5db;
}

.dark-mode .self-consent__item,
html[data-theme="dark"] .self-consent__item {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.12);
}

.dark-mode .self-consent__item--video.is-granted,
html[data-theme="dark"] .self-consent__item--video.is-granted {
  background: rgba(8, 119, 188, 0.16);
  border-color: rgba(96, 165, 250, 0.4);
}

.dark-mode .self-consent__item--heart.is-granted,
html[data-theme="dark"] .self-consent__item--heart.is-granted {
  background: rgba(255, 69, 58, 0.16);
  border-color: rgba(255, 69, 58, 0.42);
}

.dark-mode .self-consent__status,
html[data-theme="dark"] .self-consent__status {
  color: #9ca3af;
}

.dark-mode .self-consent__status.is-on,
html[data-theme="dark"] .self-consent__status.is-on {
  color: #4ade80;
}

.dark-mode .self-consent__btn--withdraw,
html[data-theme="dark"] .self-consent__btn--withdraw {
  background: rgba(255, 255, 255, 0.1);
  color: #f9fafb;
  border-color: rgba(255, 255, 255, 0.28);
}

.dark-mode .self-consent__error,
html[data-theme="dark"] .self-consent__error {
  color: #fca5a5;
}
`, "",{"version":3,"sources":["webpack://./src/components/consent/SelfConsentCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,yDAAyD;EACzD,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iEAAiE;EACjE;;8BAE4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,+DAA+D;EAC/D,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf;;;;oBAIkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;EAEE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;;EAEE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;EAEE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;EACd,uCAAuC;AACzC;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".self-consent {\n  margin: 0 0 1.25rem;\n  padding: 16px;\n  border-radius: 18px;\n  background: var(--bg-card, var(--surface-color));\n  border: var(--border-card, 1px solid var(--border-color));\n  color: var(--text-color);\n  box-sizing: border-box;\n}\n\n.self-consent__title {\n  margin: 0 0 0.35rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--text-color);\n}\n\n.self-consent__help {\n  margin: 0 0 0.9rem;\n  font-size: 0.86rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.self-consent__error {\n  margin: 0 0 0.75rem;\n  font-size: 0.9rem;\n  color: var(--brand-danger, #ff453a);\n}\n\n.self-consent__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.self-consent__item {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  margin: 0;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid var(--border-color);\n  background: color-mix(in srgb, var(--text-color) 3%, transparent);\n  transition:\n    border-color 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.self-consent__icon {\n  display: grid;\n  place-items: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 13px;\n  flex-shrink: 0;\n}\n\n.self-consent__item--video .self-consent__icon {\n  color: var(--brand-primary, #0877bc);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.self-consent__item--heart .self-consent__icon {\n  color: #ff453a;\n  background: rgba(255, 69, 58, 0.12);\n}\n\n.self-consent__item--public .self-consent__icon {\n  color: #d97706;\n  background: rgba(217, 119, 6, 0.12);\n}\n\n.self-consent__item--public.is-granted {\n  border-color: rgba(217, 119, 6, 0.34);\n  background: rgba(217, 119, 6, 0.08);\n}\n\n.self-consent__item--video.is-granted {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.38);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n}\n\n.self-consent__item--heart.is-granted {\n  border-color: rgba(255, 69, 58, 0.34);\n  background: rgba(255, 69, 58, 0.08);\n}\n\n.self-consent__item--video.is-granted .self-consent__icon {\n  color: #fff;\n  background: var(--brand-primary, #0877bc);\n}\n\n.self-consent__item--heart.is-granted .self-consent__icon {\n  color: #fff;\n  background: #ff453a;\n}\n\n.self-consent__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.self-consent__label {\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-color);\n  line-height: 1.25;\n}\n\n.self-consent__detail {\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: var(--text-secondary);\n}\n\n.self-consent__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.self-consent__status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.55;\n}\n\n.self-consent__status.is-on {\n  color: #16803c;\n}\n\n.self-consent__status.is-on .self-consent__status-dot {\n  opacity: 1;\n  box-shadow: 0 0 0 3px rgba(22, 128, 60, 0.16);\n}\n\n.self-consent__btn {\n  flex-shrink: 0;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  padding: 0.48rem 0.95rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  cursor: pointer;\n  transition:\n    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    filter 0.2s ease;\n}\n\n.self-consent__btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.self-consent__btn:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.self-consent__btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.self-consent__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.self-consent__btn--grant {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.self-consent__btn--withdraw {\n  background: var(--profile-hover-bg, transparent);\n  color: var(--text-color);\n  border-color: var(--border-color);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .self-consent__item,\n  .self-consent__btn {\n    transition: none;\n  }\n\n  .self-consent__btn:hover:not(:disabled),\n  .self-consent__btn:active:not(:disabled) {\n    transform: none;\n  }\n}\n\n.light-mode .self-consent,\nhtml[data-theme=\"light\"] .self-consent {\n  background: #f3f4f6;\n  border: 1px solid rgba(17, 24, 39, 0.12);\n  color: #111827;\n}\n\n.light-mode .self-consent__title,\n.light-mode .self-consent__label,\nhtml[data-theme=\"light\"] .self-consent__title,\nhtml[data-theme=\"light\"] .self-consent__label {\n  color: #111827;\n}\n\n.light-mode .self-consent__help,\n.light-mode .self-consent__detail,\nhtml[data-theme=\"light\"] .self-consent__help,\nhtml[data-theme=\"light\"] .self-consent__detail {\n  color: #4b5563;\n}\n\n.light-mode .self-consent__item,\nhtml[data-theme=\"light\"] .self-consent__item {\n  background: #ffffff;\n  border-color: rgba(17, 24, 39, 0.1);\n}\n\n.light-mode .self-consent__item--video.is-granted,\nhtml[data-theme=\"light\"] .self-consent__item--video.is-granted {\n  background: rgba(8, 119, 188, 0.07);\n  border-color: rgba(8, 119, 188, 0.28);\n}\n\n.light-mode .self-consent__item--heart.is-granted,\nhtml[data-theme=\"light\"] .self-consent__item--heart.is-granted {\n  background: rgba(255, 69, 58, 0.07);\n  border-color: rgba(255, 69, 58, 0.26);\n}\n\n.light-mode .self-consent__status,\nhtml[data-theme=\"light\"] .self-consent__status {\n  color: #6b7280;\n}\n\n.light-mode .self-consent__status.is-on,\nhtml[data-theme=\"light\"] .self-consent__status.is-on {\n  color: #15803d;\n}\n\n.light-mode .self-consent__btn--withdraw,\nhtml[data-theme=\"light\"] .self-consent__btn--withdraw {\n  background: #ffffff;\n  color: #111827;\n  border-color: rgba(17, 24, 39, 0.18);\n}\n\n.light-mode .self-consent__error,\nhtml[data-theme=\"light\"] .self-consent__error {\n  color: #b91c1c;\n}\n\n.dark-mode .self-consent,\nhtml[data-theme=\"dark\"] .self-consent {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: #f9fafb;\n}\n\n.dark-mode .self-consent__title,\n.dark-mode .self-consent__label,\nhtml[data-theme=\"dark\"] .self-consent__title,\nhtml[data-theme=\"dark\"] .self-consent__label {\n  color: #f9fafb;\n}\n\n.dark-mode .self-consent__help,\n.dark-mode .self-consent__detail,\nhtml[data-theme=\"dark\"] .self-consent__help,\nhtml[data-theme=\"dark\"] .self-consent__detail {\n  color: #d1d5db;\n}\n\n.dark-mode .self-consent__item,\nhtml[data-theme=\"dark\"] .self-consent__item {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.dark-mode .self-consent__item--video.is-granted,\nhtml[data-theme=\"dark\"] .self-consent__item--video.is-granted {\n  background: rgba(8, 119, 188, 0.16);\n  border-color: rgba(96, 165, 250, 0.4);\n}\n\n.dark-mode .self-consent__item--heart.is-granted,\nhtml[data-theme=\"dark\"] .self-consent__item--heart.is-granted {\n  background: rgba(255, 69, 58, 0.16);\n  border-color: rgba(255, 69, 58, 0.42);\n}\n\n.dark-mode .self-consent__status,\nhtml[data-theme=\"dark\"] .self-consent__status {\n  color: #9ca3af;\n}\n\n.dark-mode .self-consent__status.is-on,\nhtml[data-theme=\"dark\"] .self-consent__status.is-on {\n  color: #4ade80;\n}\n\n.dark-mode .self-consent__btn--withdraw,\nhtml[data-theme=\"dark\"] .self-consent__btn--withdraw {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f9fafb;\n  border-color: rgba(255, 255, 255, 0.28);\n}\n\n.dark-mode .self-consent__error,\nhtml[data-theme=\"dark\"] .self-consent__error {\n  color: #fca5a5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
